import {inject} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot} from '@angular/router';
import {NGXLogger} from 'ngx-logger';
import {firstValueFrom, timeout} from 'rxjs';
import {Store} from '@ngrx/store';
import {isAuthenticated, isGameMaster, selectCurrentCampaignId} from 'gamesis-state';
import {filter} from 'rxjs/operators';

export const campaignGuard: CanActivateFn = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const store = inject(Store);
    const router = inject(Router);
    const campaign = await firstValueFrom(store.select(selectCurrentCampaignId));
    return campaign ? true : router.createUrlTree(['/select']);
};

export const authGuard: CanActivateFn = async (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const store = inject(Store);
    const router: Router = inject(Router);
    const logger = inject(NGXLogger);

    const authenticated = await firstValueFrom(store.select(isAuthenticated));

    if (!authenticated) {
        logger.warn(`not authenticated for ${route.url}, redirecting to login page`);
    }
    return authenticated ? true : router.createUrlTree(['/login']);
};

export const gmGuard: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
) => {
    const store = inject(Store);
    return store.select(isGameMaster);
};
